/**
 * Response object for Fly Search API service
 */
class FlySearchResponseObj {
  constructor() {
    this.rawResponse = undefined
    this.clientSessionId = undefined
    this.itineraryTypeCode = undefined
    this.expressDealInfo = []
    this.expressDealDisplayableCarriers = []
  }

  setRawResponse(rawResponse) {
    this.rawResponse = rawResponse
  }

  getClientSessionId() {
    return this.clientSessionId
  }

  setClientSessionId(clientSessionId) {
    this.clientSessionId = clientSessionId
  }

  getItineraryTypeCode() {
    return this.itineraryTypeCode
  }

  setItineraryTypeCode(itineraryTypeCode) {
    if (itineraryTypeCode === 'ONE_WAY') {
      this.itineraryTypeCode = 'OW'
    } else if (itineraryTypeCode === 'MULTI_DESTINATION') {
      this.itineraryTypeCode = 'MD'
    } else if (itineraryTypeCode === 'ROUND_TRIP') {
      this.itineraryTypeCode = 'RT'
    } else if (itineraryTypeCode) {
      this.itineraryTypeCode = itineraryTypeCode
    } else {
      this.itineraryTypeCode = 'RT'
    }
  }

  getExpressDealInfo() {
    return this.expressDealInfo
  }

  addExpressDealInfo(expressDealInfo) {
    this.expressDealInfo.push(expressDealInfo)
  }

  mergeTables(originalTables, latestTables) {
    const resultingTables = {}

    for (const table in originalTables) {
      if (latestTables.hasOwnProperty(table)) {
        if (table === 'pricedItineraryTable') {
          const modifiedPricedItineraryTable = new Map()
          const offset = originalTables[table].size

          latestTables.pricedItineraryTable.forEach((value) => {
            value.id = offset + value.id
            modifiedPricedItineraryTable.set(value.id, value)
          })

          resultingTables[table] = new Map([
            ...originalTables[table],
            ...modifiedPricedItineraryTable
          ])
        } else {
          resultingTables[table] = new Map([
            ...originalTables[table],
            ...latestTables[table]
          ])
        }
      }
    }

    return resultingTables
  }

  getExpressDealDisplayableCarriers() {
    return this.expressDealDisplayableCarriers
  }

  setExpressDealDisplayableCarriers(expressDealDisplayableCarriers) {
    this.expressDealDisplayableCarriers.concat(expressDealDisplayableCarriers)
  }
}

export { FlySearchResponseObj }
